/*eslint-disable */
var $ = window.jQuery = require('jquery');
import {
  bus
} from '../../main';
export default {
  name: 'task-user-agreement-popup',
  components: {},
  props: [],
  data () {
    return {
        userId:''
    }
  },
  computed: {
  },
  mounted () {
    this.userId = localStorage.getItem('LoginedUserID')
  },
  methods: {
    closeAcknowModal(){
      return new Promise((resolve, reject) => {
        this.$store.dispatch('authUserAgreementFun', {user:  this.userId, from_page: "algo_data" } ).then((response) => { 
          bus.$emit('userAgreementStatePopupBus', false);  
          resolve(response);
        }).catch(err => {
          reject(err);
      })
    });
    }
  }
}